import React from "react";
import BejelentkezesModel from "../components/bejelentkezes/bejelentkezes";

const Bejelentkezes = () => {
  return <BejelentkezesModel />;
};

export default Bejelentkezes;
